// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { okc as _okc } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the okc chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 66
 * Chain Name: OKC
 * Default Block Explorer: https://www.oklink.com/okc
 * Default RPC URL: https://exchainrpc.okex.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { okc } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: okc,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const okc = createCommon({
	..._okc,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
